<template>
  <div>
    <Head title="Bookings" />
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item active" aria-current="page">Bookings</li>
      </ol>
    </nav>

    <h1>Bookings</h1>

    <div class="d-flex justify-content-between mb-3">
      <div class="input-group w-50">
        <button class="btn btn-primary" @click="filters = !filters">Filters</button>
        <input type="text" class="form-control" v-model="form.search">
        <button class="btn btn-outline-secondary" type="button" id="button-addon2" @click="reset">Reset</button>
      </div>

      <Link class="btn btn-primary" href="/bookings/create">
        <span>Create Booking</span>
      </Link>
    </div>

    <div class="filters-wrapper" v-show="filters">
      <div class="filters">
        <div class="row">
          <div class="col-md-3">
            <div class="filter-item mb-3">
              <label for="">Agency</label>
              <select class="form-select" v-model="form.agencies">
                <option value=""></option>
                <option :value="agency.name" v-for="agency in agencies" :key="agency.id">{{ agency.name }}</option>
              </select>
            </div>
          </div>

          <div class="col-md-3">
            <div class="filter-item mb-3">
              <label for="">Status</label>
              <select class="form-select" v-model="form.status">
                <option value=""></option>
                <option value="draft">Draft</option>
                <option value="request">Request</option>
                <option value="offer">Offer</option>
                <option value="reservation">Reservation</option>
                <option value="booked">Booked</option>
                <option value="cancelled">Cancelled</option>
              </select>
            </div>
          </div>

          <div class="col-md-6">
            <div class="filter-item">
              <label for="">Booking Date</label>

              <div class="row">
                <div class="col-md-6">
                  <div class="input-group mb-3">
                    <span class="input-group-text" id="basic-addon1">From</span>
                    <input type="date" class="form-control" v-model="form.date_from">
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="input-group mb-3">
                    <span class="input-group-text" id="basic-addon1">To</span>
                    <input type="date" class="form-control" v-model="form.date_to">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="content-box">
      <table class="table">
        <thead>
          <tr>
            <th>Booking #</th>
            <th>Agency</th>
            <th>Status</th>
            <th>Route</th>
            <th>Booking Date</th>
            <th>Customer</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="booking in bookings.data" :key="booking.id">
            <td>
              <Link :href="`/bookings/${booking.id}/edit`">
                {{ booking.booking_number }}
              </Link>
            </td>
            <td>
              <Link :href="`/bookings/${booking.id}/edit`">
                {{ booking.agency[0].name }}
              </Link>
            </td>
            <td>
              <Link :href="`/bookings/${booking.id}/edit`">
                {{ booking.status }}
              </Link>
            </td>
            <td>
              <Link :href="`/bookings/${booking.id}/edit`" v-if="booking.journeys.length">
                {{ findAirport(booking.journeys[0].departure.from).iata }} - {{ findAirport(booking.journeys[0].departure.to).iata }}
              </Link>
            </td>
            <td>
              <Link :href="`/bookings/${booking.id}/edit`">
                {{ $filters.formatDate(booking.created_at) }}
              </Link>
            </td>
            <td>
              <Link :href="`/bookings/${booking.id}/edit`">
                {{ booking.customers[0].first_name }} {{ booking.customers[0].middle_name }} {{ booking.customers[0].last_name }}
              </Link>
            </td>
            <td>
              <Link :href="`/bookings/create/${booking.id}`">
                Duplicate
              </Link>
            </td>
          </tr>
          <tr v-if="bookings.data.length === 0">
            <td colspan="7">No bookings found.</td>
          </tr>
        </tbody>
      </table>
    </div>
    <pagination class="mt-3" :links="bookings.links" />
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'

export default {
  components: {
    Head,
    Icon,
    Link,
    Pagination,
    SearchFilter,
  },
  layout: Layout,
  props: {
    filters: Object,
    bookings: Object,
    airports: Object,
    agencies: Object
  },
  data() {
    return {
      filters: false,
      form: {
        search: this.filters.search,
        status: this.filters.status,
        date_from: this.filters.date_from,
        date_to: this.filters.date_to,
        trashed: this.filters.trashed,
        agencies: this.filters.agency,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.filters = true;
        this.$inertia.get('/bookings', pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
    findAirport(airportId) {
      return this.airports.filter(function(item){
          if(item.id == airportId) return item;
      })[0]
    }
  },
}
</script>
